export default __webpack_public_path__ + "static/media/ev-wall-cable-white.104f1577.jpg";